export const baseMediaUrl = 'https://culturemedia.s3.amazonaws.com/';
